var t=t=>{let e=!1;try{new EventTarget().addEventListener("option-test",()=>{},{get[t](){return e=!0}})}catch(t){e=!1}return e};export{t as default};